import {configureStore} from "@reduxjs/toolkit"
import env from "../config/env"
import requestReducer from "./request"
import recentsReducer from "./recents"
import searchReducer from "./search"
import shoppingBagReducer from "./shoppingbag"
import headerReducer from "./headerdata"
import userReducer from "./user"
import autocompleteReducer from "./autocomplete"
import languageReducer from "./languages"
import textAlignmentReducer from "./text-alignment"
import textReducer from "./text"
import favouritesReducer from "./favourites"
import countrySelectorReducer from "./country-selector"
import templateReducer from "./template"
import AppState from "./state"
import {settingsReducer} from "./settings"
import primarynavReducer from "./primary-nav"
import secondarynavReducer from "./secondary-nav"
import accordionActivityReducer from "./accordion-activity"
import tabsActivityReducer from "./tabs-activity"
import messageBannerReducer from "./messageBanner"

export type State = AppState

const {DEVELOPMENT} = env

export const rootReducer = {
    user: userReducer,
    recents: recentsReducer,
    request: requestReducer,
    search: searchReducer,
    shoppingBag: shoppingBagReducer,
    languages: languageReducer,
    data: headerReducer,
    textAlignment: textAlignmentReducer,
    autocomplete: autocompleteReducer,
    favourites: favouritesReducer,
    countrySelector: countrySelectorReducer,
    text: textReducer,
    template: templateReducer,
    settings: settingsReducer,
    primarynav: primarynavReducer,
    secondarynav: secondarynavReducer,
    accordionActivity: accordionActivityReducer,
    tabsActivity: tabsActivityReducer,
    messageBanner: messageBannerReducer,
}

type Reducers = typeof rootReducer
type ActionTypes = {
    [K in keyof Reducers]: Parameters<Reducers[K]>[1]
}

export const makeStore = (initialState?: State) => {
    return configureStore<State, ActionTypes[keyof ActionTypes]>({
        reducer: rootReducer,
        devTools: DEVELOPMENT,
        preloadedState: initialState,
    })
}
